'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FloorSuckerIcon = function FloorSuckerIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M49 94h13v8H49zM71 94h13v8H71z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M43 62h46v35H43zM43 43h46v13H43z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M50 53h33v13H50zM55 33h22v13H55zM29.21 80.313c1.712-1.75 5.137-1.75 6.85 0 1.141 1.166 1.474 3.5 1 7h-8.85c-.476-3.5-.142-5.834 1-7z'
            }),
            _react2.default.createElement('path', {
                d: 'M36.412 87.08v-4.032a3.52 3.52 0 0 0-3.52-3.513h-.521a3.52 3.52 0 0 0-3.52 3.513v4.032h7.561zm1.28-4.032v4.67c0 .352-.287.64-.64.64h-8.841a.641.641 0 0 1-.642-.64v-4.67c0-2.641 2.155-4.79 4.802-4.79h.52a4.8 4.8 0 0 1 4.8 4.79z',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M36.412 87.08v-4.032a3.52 3.52 0 0 0-3.52-3.513h-.521a3.52 3.52 0 0 0-3.52 3.513v4.032h7.561zm1.28-4.032v4.67c0 .352-.287.64-.64.64h-8.841a.641.641 0 0 1-.642-.64v-4.67c0-2.641 2.155-4.79 4.802-4.79h.52a4.8 4.8 0 0 1 4.8 4.79z',
                stroke: '#555',
                strokeWidth: '.6'
            }),
            _react2.default.createElement('path', {
                d: 'M29.53 87.718v2.714a.638.638 0 0 1-.64.638.639.639 0 0 1-.64-.638v-2.714a.64.64 0 0 1 1.28 0',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M29.53 87.718v2.714a.638.638 0 0 1-.64.638.639.639 0 0 1-.64-.638v-2.714a.64.64 0 0 1 1.28 0z',
                stroke: '#555',
                strokeWidth: '.6'
            }),
            _react2.default.createElement('path', {
                d: 'M37.012 87.718v2.714a.638.638 0 0 1-.64.638.639.639 0 0 1-.641-.638v-2.714a.64.64 0 0 1 1.281 0',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M37.012 87.718v2.714a.638.638 0 0 1-.64.638.639.639 0 0 1-.641-.638v-2.714a.64.64 0 0 1 1.281 0z',
                stroke: '#555',
                strokeWidth: '.6'
            }),
            _react2.default.createElement('path', {
                d: 'M33.27 87.718v4.749a.64.64 0 1 1-1.278 0v-4.75a.64.64 0 0 1 1.279 0',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M33.27 87.718v4.749a.64.64 0 1 1-1.278 0v-4.75a.64.64 0 0 1 1.279 0z',
                stroke: '#555',
                strokeWidth: '.6'
            }),
            _react2.default.createElement('path', {
                d: 'M50.108 61.07h31.615v-3.03H50.108v3.03zM43.75 89.042V62.895h44.328V95.58H43.751v-6.537zm27.64 12.565h10.332v-4.202H71.39v4.202zm-21.423 0h10.687v-4.202H49.968v4.202zm-8.334-46.596v3.027h6.07v3.03l-6.012-.071v3.026l.127 33.309 5.904.073v6.056h15.175v-6.056h6.072v6.056h15.175v-6.056h6.051V61.07h-6.07v-3.03h6.07v-15.14H41.634v12.113zm2.117.948h44.33V44.98h-44.33V55.96z',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M76.512 42.984l.021-8.611c.008-1.11-1.564-2.018-3.515-2.032M73.018 32.34l-14.12-.07c-1.952-.014-3.535.875-3.543 1.983l-.045 8.612',
                stroke: '#555',
                strokeWidth: '1.875'
            }),
            _react2.default.createElement('path', {
                d: 'M32.613 52.356V79.65',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                d: 'M32.613 52.356V79.65M32.632 52.905c0-29.428 7.22-31.962 17.115-31.962 8.392 0 11.524 5.38 12.428 10.507',
                stroke: '#555',
                strokeWidth: '1.875'
            }),
            _react2.default.createElement('path', {
                d: 'M75.842 62.894v24.47M75.842 89.247v7.53M42.797 50.47h37.736M82.42 50.47h5.66',
                stroke: '#555',
                strokeWidth: '2'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M109.31 102.11v2H21.156v-2zM109.31 108.528v2H21.156v-2z'
            })
        )
    );
};

FloorSuckerIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var FloorSucker = function (_React$Component) {
    _inherits(FloorSucker, _React$Component);

    function FloorSucker() {
        _classCallCheck(this, FloorSucker);

        return _possibleConstructorReturn(this, (FloorSucker.__proto__ || Object.getPrototypeOf(FloorSucker)).apply(this, arguments));
    }

    _createClass(FloorSucker, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(FloorSuckerIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return FloorSucker;
}(_react2.default.Component);

exports.default = FloorSucker;